import { useMemo } from 'react';
import type {
  Order,
  SortableFields,
} from '~/components/SearchResultsTable/types';

const isSortableOrder = (value: string | undefined): value is Order => {
  const orders: Order[] = ['asc', 'desc'];
  return !!value && orders.includes(value.toLowerCase() as Order);
};
const isSortableField = (
  value: string | undefined
): value is SortableFields => {
  const sortableFields: SortableFields[] = [
    'rank',
    'spend_min',
    'updated_at',
    'employees',
  ];
  return !!value && sortableFields.includes(value as SortableFields);
};

export const defaultSortString = 'updated_at DESC';

export default function useSortFromQueryParam(
  sort: string | undefined
): [string, SortableFields, Order] {
  return useMemo(() => {
    const results = getSortFromQueryParam(sort || '');
    return results;
  }, [sort]);
}

export function getSortFromQueryParam(
  sort: string
): [string, SortableFields, Order] {
  const [field, order] = sort.split(' ');
  if (isSortableField(field) && isSortableOrder(order)) {
    return [
      `${field} ${order.toUpperCase()}`,
      field.toLowerCase() as SortableFields,
      order.toLowerCase() as Order,
    ];
  }
  return getSortFromQueryParam(defaultSortString);
}
